import { Link } from 'react-router-dom';
import { Code, GitBranch } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 border-t
                       border-gray-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4
                      sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1
                        md:grid-cols-4 gap-8">

          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/"
                  className="flex items-center
                             space-x-2 mb-4">
              <div className="bg-blue-600 p-1.5 rounded-lg">
                <Code className="w-5 h-5 text-white" />
              </div>
              <span className="font-bold text-xl text-white">
                Scaffold
                <span className="text-blue-500">Bridge</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm
                          max-w-xs leading-relaxed">
              Generate production-ready .NET 8 and
              Java Spring Boot (Maven) projects from OpenAPI
              specs or SQL schemas in seconds.
            </p>
            <div className="flex items-center space-x-4 mt-4">
              <a href="https://github.com"
                 target="_blank"
                 rel="noreferrer"
                 className="text-gray-500 hover:text-white
                            transition-colors">
                <GitBranch className="w-5 h-5" />
              </a>
              <a href="https://twitter.com"
                 target="_blank"
                 rel="noreferrer"
                 className="text-gray-500 hover:text-white
                            transition-colors">
                <svg className="w-5 h-5"
                     viewBox="0 0 24 24"
                     fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227
                          8.26 8.502 11.24H16.17l-4.714
                          -6.231-5.401 6.231H2.744l7.73
                          -8.835L1.254 2.25H8.08l4.713
                          6.231zm-1.161 17.52h1.833L7.084
                          4.126H5.117z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-white font-semibold
                           mb-4 text-sm uppercase
                           tracking-wider">
              Product
            </h3>
            <ul className="space-y-2">
              {[
                { label: 'Pricing',   to: '/#pricing',   isAnchor: true  },
                { label: 'Docs',      to: '/#docs',      isAnchor: false },
              ].map(item => (
                <li key={item.label}>
                  {item.isAnchor ? (
                    // Use <a> for anchor scroll ✅
                    // In Footer.tsx replace Pricing <a> tag:
                       <a
                          href="/#pricing"
                          onClick={e => {
                            e.preventDefault();
                            // If already on home page scroll ✅
                            const el = document
                              .getElementById('pricing');
                            if (el) {
                              el.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                              });
                            } else {
                              // Navigate to home then scroll ✅
                              window.location.href = '/#pricing';
                            }
                          }}
                          className="text-gray-400 hover:text-white
                                    text-sm transition-colors">
                          Pricing
                        </a>
                  ) : (
                    <Link
                      to={item.to}
                      className="text-gray-400 hover:text-white
                                 text-sm transition-colors">
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold
                           mb-4 text-sm uppercase
                           tracking-wider">
              Company
            </h3>
            <ul className="space-y-2">
              {[
                { label: 'About',            to: '/#about'    },
                { label: 'Privacy Policy',   to: '/privacy'   },
                { label: 'Terms of Service', to: '/terms'     },
                { label: 'Contact',          to: '/contact'   },
              ].map(item => (
                <li key={item.label}>
                  {item.to.startsWith('http') ? (
                    <a
                      href={item.to}
                      target="_blank"
                      rel="noreferrer"
                      className="text-gray-400 hover:text-white
                                 text-sm transition-colors">
                      {item.label}
                    </a>
                  ) : (
                    <Link
                      to={item.to}
                      className="text-gray-400 hover:text-white
                                 text-sm transition-colors">
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8
                        flex flex-col sm:flex-row items-center
                        justify-between">
          <p className="text-gray-500 text-sm">
            © 2026 ScaffoldBridge. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm mt-2 sm:mt-0">
            Built with ❤️ by
            <span className="text-blue-500 ml-1">
              RenegadeRegime
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;